import Weather from './components/Weather';

function App() {
  return (
    <div>
       <Weather />
    </div>
  );
}

export default App;
